import { TypedAction } from '@ngrx/store/src/models';
import { AppStateFailureBuilder, AppStateFailureItemWithErrorCode, FailureType } from '@symphony-solo/shared/common-state/src';
import { ErrorCode, Validator } from '@symphony-solo/shared/error-handling/src';
import { loadTaxRateShiftsSuccessAction } from '../+state';
import { TaxRateShiftsDto } from '../dtos';

export class TaxRateShiftsValidator extends Validator<TaxRateShiftsDto[]> {
  public validate(): TypedAction<any> {
    if (this.data?.length > 0) {
      return loadTaxRateShiftsSuccessAction({ taxrateShifts: this.data });
    }
    throw new AppStateFailureBuilder()
      .setFailureType(FailureType.Validation)
      .addFailure(new AppStateFailureItemWithErrorCode('No Taxrate Shifts', ErrorCode.NoTaxRateShifts))
      .build();
  }
}
